import { render, staticRenderFns } from "./GiftTimer.vue?vue&type=template&id=65ff04c2&scoped=true&"
import script from "./GiftTimer.vue?vue&type=script&lang=js&"
export * from "./GiftTimer.vue?vue&type=script&lang=js&"
import style0 from "./GiftTimer.vue?vue&type=style&index=0&id=65ff04c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff04c2",
  null
  
)

export default component.exports